export const vcAPI = "https://api.virtualcampusmfm.com";